import { BaseResponseMapper } from './Base'
import { Pagination } from '@/domain/entities/Pagination'
import {
  TrainingMaterial,
  TrainingMaterialData,
} from '@/domain/entities/TrainingMaterial'
import { AxiosResponse } from 'axios'

export class TrainingMaterialDataMapper extends BaseResponseMapper {
  public convertFromApi(result: AxiosResponse<any>): TrainingMaterial {
    const { data } = result
    return new TrainingMaterial(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new TrainingMaterialData(
            val.id,
            val.category_id,
            val.title,
            val.file,
            val.is_recommended,
            val.owner,
            val.image_thumbnail,
            val.created_at,
            val.updated_at,
            val.expireddate
          )
      )
    )
  }
}
